/*
 * @bot-written
 *
 * WARNING AND NOTICE
 * Any access, download, storage, and/or use of this source code is subject to the terms and conditions of the
 * Full Software Licence as accepted by you before being granted access to this source code and other materials,
 * the terms of which can be accessed on the Codebots website at https://codebots.com/full-software-licence. Any
 * commercial use in contravention of the terms of the Full Software Licence may be pursued by Codebots through
 * licence termination and further legal action, and be required to indemnify Codebots for any loss or damage,
 * including interest and costs. You are deemed to have accepted the terms of the Full Software Licence on any
 * access, download, storage, and/or use of this source code.
 *
 * BOT WARNING
 * This file is bot-written.
 * Any changes out side of "protected regions" will be lost next time the bot makes any changes.
 */
import { Link, useLocation } from 'react-router-dom';
import OrganisationContextSwitcher from '../EntitySwitcher/OrganisationContextSwitcher';
// % protected region % [Add any extra imports here] on begin
import { fetchTopbarOrganisationOptions } from 'Hooks/Api/apiOrganisation';
import { isGuid } from 'Util/StringUtils';
import { store } from 'Models/Store';
// % protected region % [Add any extra imports here] end

export type uiLocation = 'frontend' | 'admin';
export interface ITopBarProps {
	/** The current location of the application */
	currentLocation: uiLocation;

	// % protected region % [Add any extra props here] off begin
	// % protected region % [Add any extra props here] end
}

/**
 * The Topbar component displays the topbar for admins to toggle between the frontend and the backend
 */
// % protected region % [Add any customisations to default class definition here] on begin


/**
 * Majority of pages will support org switching.
 * However, there are some pages where we specifically do not want to let them change organisations
 */
function doesPathSupportOrgSwitching(pathname: string): boolean {

	// Hide on customer profile - should not be able to see Org1 custoemr profile when switched to Org2
	const customerProfilePrefix = "/monitor/customers/";
	if (pathname.startsWith(customerProfilePrefix)) {
		const idPart = pathname.substring(customerProfilePrefix.length);
		if (isGuid(idPart)) return false;
	}

	// Hide others as you come across them
	return true;
}

function FrontendBackendLink(props: ITopBarProps) {
	const { currentLocation } = props;
	const to = currentLocation === 'admin' ? "/" : "/admin";
	const text = currentLocation === 'admin' ? "Frontend" : "Admin";
	return <Link to={to} className="icon-right icon-arrow-right-up link-rm-txt-dec active">{text}</Link>;
}

function Topbar(props: ITopBarProps) {
	// % protected region % [Add any customisations to default class definition here] end

	// % protected region % [Override buttonLink here] on begin
	// % protected region % [Override buttonLink here] end

	// % protected region % [Override render here] on begin
	const { currentLocation } = props;
	const location = useLocation();

	if (!store.hasBackendAccess) return <></>

	const displayOrgSwitcher = currentLocation !== 'admin' && store.getUser?.userType === 'SUPER_USER' && doesPathSupportOrgSwitching(location.pathname);

	return (
		<div className="admin__top-bar">
			{displayOrgSwitcher && (
				<OrganisationContextSwitcher
					value={store.impersonatingOrganisationId}
					setValue={id => {
						if (id) store.impersonatingOrganisationId = id;
					}}
					getOptions={term => fetchTopbarOrganisationOptions(location.pathname, term)}
				/>
			)}
			<ul>
				<li>
					<FrontendBackendLink currentLocation={currentLocation} />
				</li>
			</ul>
		</div>
	);
	// % protected region % [Override render here] end

	// % protected region % [Add any extra methods here] off begin
	// % protected region % [Add any extra methods here] end
}

// % protected region % [Override export here] off begin
export default Topbar;
// % protected region % [Override export here] end
